<template>
  <div :class="{demoNotice: true, demoNoticeCenter: !!alert}">

    <b-modal v-model="showModal" size="xl"  id="modalPopover" :title="title" hide-footer>
      <div  v-if="completed">
        <h1 class="page-title"> Purchase Completed </h1>
        <Widget  class="">
          <b-alert variant="success" show>Your subscription has been successfully processed.</b-alert>

          <b-button :to="{ name: 'NewPage'}" variant="info">Add Website</b-button>
        </Widget>
      </div>
      <div v-else>
      <div class="demo-pricing">
        <b-row  class="justify-content-md-center">


          <b-col xs="9" md="9" lg="9">
        <h4>Monitor up to <span style="color:#009cea"><b>{{pricing[pageCountIndex]['pages']}}</b></span> pages per site</h4>
        <b-form-input v-model="pageCountIndex" type="range" min="0" max="5" step="1"></b-form-input>
        <b-alert variant="info" show v-if="userHasActivePlan && planIsCustom">You are on a custom plan, please contact us to change your subscription.</b-alert>

        <p></p>
          </b-col>
        </b-row>
      <b-row  class="justify-content-md-center">


        <b-col xs="6" md="6" lg="3">
          <Widget
                  style="text-align:center;border:0px solid #95d0ff;padding-left:2px;padding-right:2px">
            <h3>Basic</h3>
            <div class="pricing">
              <sup>$</sup>{{pricing[pageCountIndex]['p1']}}<span class="monthindicator"> / month</span></div>
            <div>
              <ul style="text-align:left;margin-left:22px;line-height:36px">
                </li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> {{pricing[pageCountIndex]['pages'] * tests_per_page_per_tier[0]}} Tests Per Month
                  <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`A test is a complete audit of a single page.`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i>
                </li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Unlimited Sites</li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Includes All Checks</li>


              </ul>
            </div>
            <b-button variant="success" style="float:bottom" @click="purchase('basic', pricing[pageCountIndex]['pages'])" :disabled="planIsCustom || (userHasActivePlan && subscription.websites_plan.name === 'basic' && subscription.pages_per_audit === pricing[pageCountIndex]['pages'])">
              <span v-if="!userHasActivePlan">Choose Plan</span>
              <span v-else-if="subscription.websites_plan.name === 'basic' && subscription.pages_per_audit === pricing[pageCountIndex]['pages']">Selected</span>
              <span v-else>Update Subscription</span>
            </b-button>
          </Widget>
        </b-col>


        <b-col xs="6" md="6" lg="3">
          <Widget
                  style="text-align:center;border:2px solid #95d0ff;padding-left:2px;padding-right:2px;  overflow:hidden;">
            <h3>Business</h3>
            <div class="popular">Popular</div>
            <div class="pricing">
              <sup>$</sup>{{pricing[pageCountIndex]['p2']}}<span class="monthindicator"> / month</span></div>
            <div>
              <ul style="text-align:left;margin-left:22px;line-height:36px">
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> {{pricing[pageCountIndex]['pages'] * tests_per_page_per_tier[1]}} Tests Per Month
                  <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`A test is a complete audit of a single page.`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i>
                </li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Unlimited Sites</li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> 3 Months History</li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> API/CI integration</li>
              </ul>
            </div>
            <b-button variant="success" style="float:bottom" @click="purchase('business', pricing[pageCountIndex]['pages'])" :disabled="planIsCustom || (userHasActivePlan && subscription.websites_plan.name === 'business' && subscription.pages_per_audit === pricing[pageCountIndex]['pages'])">
              <span v-if="!userHasActivePlan">Choose Plan</span>
              <span v-else-if="subscription.websites_plan.name === 'business' && subscription.pages_per_audit === pricing[pageCountIndex]['pages']">Selected</span>
              <span v-else>Update Subscription</span>
            </b-button>
          </Widget>
        </b-col>

        <b-col xs="6" md="6" lg="3">
          <Widget
                  style="text-align:center;padding-left:2px;padding-right:2px">
            <h3>Pro</h3>
            <div class="pricing">
              <sup>$</sup>{{pricing[pageCountIndex]['p3']}}<span class="monthindicator"> / month</span></div>
            <div>
              <ul style="text-align:left;margin-left:22px;line-height:36px">
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> {{pricing[pageCountIndex]['pages'] * tests_per_page_per_tier[2]}} Tests Per Month
                  <i data-toggle="tooltip" data-placement="top" data-html="true" v-b-tooltip.hover="`A test is a complete audit of a single page.`" class="fa fa-info-circle" style="color:gray;font-size:14px"></i>
                </li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> Unlimited Sites</li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> 6 Months History</li>
                <li><i class="fa fa-check-circle-o" style="color:#28a745;font-size:20px;"></i> API/CI integration</li>
              </ul>
            </div>
            <b-button variant="success" style="float:bottom" @click="purchase('pro', pricing[pageCountIndex]['pages'])" :disabled="planIsCustom || (userHasActivePlan && subscription.websites_plan.name === 'pro' && subscription.pages_per_audit === pricing[pageCountIndex]['pages'])">
              <span v-if="!userHasActivePlan">Choose Plan</span>
              <span v-else-if="subscription.websites_plan.name === 'agency' && subscription.pages_per_audit === pricing[pageCountIndex]['pages']">Selected</span>
              <span v-else>Update Subscription</span>
            </b-button>
          </Widget>
        </b-col>





      </b-row>

        <b-alert show variant="danger" v-if="error">{{error}}</b-alert>
        All plans come with a 30 day money back guarantee.

      </div>


      </div>
      <Widget title="More Options" v-if="userHasActivePlan">
      <p><a :href="subscription.paddle_update_billing_url">Update Payment Method</a></p>
      <div>
        <b-button v-b-toggle.collapse-1 variant="secondary" size="sm">Cancel Subscription</b-button>
        <b-collapse id="collapse-1" class="mt-2">
          <b-card>
            <b-alert variant="warning" show style="color:#856404;background-color:#fff3cd">Warning: This will stop your subscription and all recurring website audits, you will no longer have access to any historical data.<p>
            </p></b-alert>
            <b-button variant="danger" size="sm" :href="subscription.paddle_cancel_url">Cancel Subscription</b-button>
          </b-card>
        </b-collapse>
      </div>
      </Widget>
      <Widget title="Frequently Asked Questions" v-if="!userHasActivePlan">
        <div>
        <b>Can I track multiple sites?</b><br>
          <small>Yes you can divide your tests between as many sites as want.</small>
          <p></p>
          <b>Can I change plans later?</b><br>
          <small>Yes you can change or cancel plans any time, you will be pro-rated for the period you are in.</small>
          <p></p>
        </div>
      </Widget>
      <div style="padding:10px" v-if="!userHasActivePlan">
      <small style="font-size:10px;color:gray">Our order process is conducted by our online reseller & Merchant of Record, Paddle.com, who also handle order related inquiries and returns.</small>
      </div>
    </b-modal>

    <b-alert show variant="warning" v-if="alert">
    <div>
      {{alert}}
    </div>
    <b-button variant="success" @click="showModal=true">{{button}}<span v-if="angleRight"> &nbsp; <i class="fa fa-angle-right"></i></span></b-button>
    </b-alert>
    <div v-else>
      <b-button variant="success" @click="showModal=true">{{button}}<span v-if="angleRight"> &nbsp; <i class="fa fa-angle-right"></i></span></b-button>
    </div>
  </div>
</template>
<script>
  import Widget from '@/components/Widget/Widget';
  import axios from "axios";
  import { mapState } from "vuex";
  import gql from "graphql-tag";

  export default {
  name: 'Loader',
  components: { Widget },
  props: {
    angleRight: {type: Boolean, default: true},
    show: {type: Boolean, default: false},
    initiatePurchase: {type: String, default: ''},
    title: {type: String, default: 'Choose a Plan'},
    button: {type: String, default: 'Monitor all your pages'},
    alert: {type: String, default: ''},
  },
  data(){
    return {
      completed: false,
      showModal: this.show,
      error: '',
      subscription: {},
      submitting: false,
      userHasActivePlan: false,
      pageCountIndex: 1,
      planIsCustom: false,
      tests_per_page_per_tier:[8, 25, 60],
      pricing:[
        {pages: 25, p1: 29, p2: 49, p3: 79},
        {pages: 50, p1: 49, p2: 89, p3: 129},
        {pages: 100, p1: 69, p2: 129, p3: 199},
        {pages: 250, p1: 109, p2: 239, p3: 449},
        {pages: 500, p1: 189, p2: 399, p3: 759},
        {pages: 1000, p1: 349, p2: 709, p3: 1359},
      ],
      price:{
        free: {base: 0, pages: 50, devices: 4, maxAudit: 25},
        hobby: {base: 9, pages: 125, devices: 4, maxAudit: 25},
        startup: {base: 29, pages: 500, devices: 4, maxAudit: 100},
        business:  {base: 89, pages: 1500, devices: 4, maxAudit: 250},
        agency:  {base: 189, pages: 4000, devices: 4, maxAudit: 500},
      },
    }
  },
    apollo: {
      $subscribe: {
        websites_website: {
          query() {
            return gql`subscription {
                  websites_subscription {
                    state
                    pages_per_audit
                    paddle_cancel_url
                    paddle_update_billing_url
                    websites_plan{
                      name
                    }
                  }
          }`
          },
          skip () {
            return false;
          },
          result (data) {
            this.loading = true;

            this.subscription = data.data.websites_subscription[0];
            if (this.subscription) {
              this.userHasActivePlan = this.subscription.websites_plan.name !== 'free' && this.subscription.state === 'active';
              this.planIsCustom = ['free', 'hobby', 'startup', 'business', 'agency', 'basic', 'pro'].indexOf(this.subscription.websites_plan.name) === -1;
              this.pageCountIndex = this.pricing.findIndex( (p) => p.pages === this.subscription.pages_per_audit)
              if (this.pageCountIndex < 0){
                this.pageCountIndex = 1;
              }
            }
            else{
              this.userHasActivePlan = false;
            }
            this.loading = false;

          },

        },

      }
    },
  methods: {
    closeCallback(){
      this.submitting = false;
    },
    successCallback(){
      this.completed = true;
      this.submitting = false;
    },
    purchase(plan, pages){
      this.submitting = true;
      this.error = '';

      if (this.user.role === 'demo'){
        //return this.$router.push({name: 'Register', query: {'next': `/admin/account/sites?purchase=${plan}`}});
        // window.location = "/register?next=" + encodeURIComponent(`/admin/account/sites?purchase=${plan}`)
        window.location = "/register";
        return;
      }

      axios
              .post(`payments/generate_paddle`, {
                plan: plan,
                pages: pages,
              })
              .then(
                      response => {
                        if (response.data.success) {
                          if (response.data.show_form) {
                            window.Paddle.Checkout.open({
                              allowQuantity: false,
                              override: response.data.url,
                              closeCallback: this.closeCallback,
                              successCallback: this.successCallback,
                            });
                          }
                          else{
                            this.completed = true;
                          }
                        }
                        else{
                          this.$toast.show('Unable to process subscription, please try again later', 'Payment Error', this.toastOptions);
                        }
                        return true;
                      },
                      error => {
                        this.submitting = false;
                        if (error.response.data && error.response.data.message) {
                          this.error = error.response.data.message;
                        }
                        else{
                          this.error = 'There was an error processing your request, please try again.';
                        }
                      }
              );
    },
  },
  computed: {
    ...mapState({  user: "user" }),


  },
  mounted() {
    this.submitting = false;
    this.$loadScript("https://cdn.paddle.com/paddle/paddle.js")
            .then(() => {
              // Script is loaded, do something
              window.Paddle.Setup({ vendor: 109078 });
              if (this.initiatePurchase && this.user.plan === 'free'){
                this.purchase(this.initiatePurchase);
              }
            })
            .catch(() => {
            });
  },
}
</script>

<style src="./DemoNotice.scss" lang="scss"/>
